module.exports = __webpack_public_path__ + "img/ccac533.jpg";